import React from 'react';
import './PurchaseLoginModal.scss';
import ReactModal from 'react-modal';
import { IPurchaseLoginModalProps } from './IPurchaseLoginModalProps';
import useForm from 'utils/validator/validator';
import { AuthorizeService } from 'api/services/authorize';
import { toast } from 'react-toastify';
import { connect } from "react-redux";
import { Map } from "immutable";
import miscUtils from 'utils/miscUtils';
import { ReactComponent as XIcon } from 'containers/channels/collections/deleteConfirmation/icons/x.svg';
import { useAtom } from 'jotai';
import { isHumanVerifiedAtom } from 'showMessageMenuAtom'
import TurnstileWidget from 'components/TurnstileWidget/TurnstileWidget';
import { useTurnstile } from 'react-turnstile';

const PurchaseLoginModal: React.FC<IPurchaseLoginModalProps> = (props) => {
  const [isHumanVerified, setisHumanVerified] = useAtom(isHumanVerifiedAtom) as any;
  const [userDetails, setUserDetails] = React.useState({
    email: "",
    password: "",
  });
  const [isMakingRequest, setIsMakingRequest] = React.useState<boolean>(false);

  const turnstileWidgetIsAvailable = document.getElementById('cloudflaire-turnstile-widget');
  const isDisabled = () => {
    return (!isHumanVerified.isVerified && (turnstileWidgetIsAvailable !== null))
  }

  const turnstile = useTurnstile();
  const [reloadKey, setReloadKey] = React.useState<number>(0);

const reloadComponent = () => {
  setReloadKey(prev => prev + 1); // Trigger re-render
};

  const login = async () => {
    setIsMakingRequest(true);
    try {
      if (turnstileWidgetIsAvailable === null) {
        await AuthorizeService.getInstance()
          .login(userDetails.email, userDetails.password, props.ip, props.ua, undefined, props.group.id);
      } else {
        await AuthorizeService.getInstance()
          .login(userDetails.email, userDetails.password, props.ip, props.ua, isHumanVerified.session_token, props.group.id)
          .finally(()=>{
            setisHumanVerified({
           isVerified: false,
           session_token: undefined
         });
           turnstile.reset();
           reloadComponent();
          });
      }

      setIsMakingRequest(false);
      props.close();
    } catch (error) {
      toast(`${(error as any).data.message}`, {
        type: 'error',
        autoClose: 2000,
        position: "top-center",
        hideProgressBar: true,
        theme: "light"
      });
      setIsMakingRequest(false);
    }
  }

  const { errors, handleSubmit } = useForm(login, userDetails);

  const changeUserDetails = (event: any) => {
    setUserDetails({
      ...userDetails,
      [event.target.name]: event.target.value,
    });
  }

  const [isValidImage, setIsValidImage] = React.useState(true);
  const onImageError = (e: any) => {
    setIsValidImage(false)
  }

  return (
    <ReactModal
      isOpen={props.isOpen}
      style={{
        content: {
          width: "496px",
          maxWidth: "calc(100vw - 10px)",
          height: "auto",
          borderRadius: '0.5rem',
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          position: "fixed",
          background: "white",
          border: 0,
          padding: 0,
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 99999,
        }
      }}
    >
      <div
        className="groupapp-purchase-login-account-container"
      >
        <div
          className="groupapp-purchase-login-account-close"
          onClick={props.close}
        >
          <XIcon />
        </div>

        {props.group && (
          <div className="groupapp-purchase-login-group-info">
            {props.group.profile_image && isValidImage ? (
              <img src={props.group.profile_image} alt="Group profile image" className="groupapp-purchase-login-profile-image" onError={onImageError} />
            )
              :
              <div className="groupapp-purchase-login-group-info-profile-image" data-color={miscUtils.getColorInitial(props.group.name)}>
                <h1 className="groupapp-purchase-login-group-info-group-name-image">{miscUtils.getNameInitials(props.group.name)}</h1>
              </div>
            }
            <h3 className="groupapp-purchase-login-group-name">{props.group.name}</h3>
          </div>
        )}

        <p
          className="groupapp-purchase-login-account-title"
        >Log In</p>

        <p
          className="groupapp-purchase-login-account-subtitle"
        >Log in to your account for this community</p>

        <div
          className="groupapp-purchase-login-account-content-container"
        >
          <div
            className="groupapp-purchase-login-account-content-input-container"
          >
            <p
              className="groupapp-purchase-login-account-content-input-label"
            >Email address <small style={{ color: 'red' }}>{" "}*</small></p>
            <input
              type="text"
              name="email"
              value={userDetails.email}
              onChange={changeUserDetails}
              placeholder="Enter email address"
              className="groupapp-purchase-login-account-content-input-field"
            />
            <div
              className="groupapp-purchase-login-account-content-input-error-container"
            >{errors.email && errors.email.errorComponent}</div>
          </div>

          <div
            className="groupapp-purchase-login-account-content-input-container"
          >
            <p
              className="groupapp-purchase-login-account-content-input-label"
            >Password <small style={{ color: 'red' }}>{" "}*</small></p>
            <input
              type="password"
              form-datatype='password'
              name="password"
              value={userDetails.password}
              onChange={changeUserDetails}
              placeholder="********"
              className="groupapp-purchase-login-account-content-input-field"
            />
            <div
              className="groupapp-purchase-login-account-content-input-error-container"
            >{errors.password && errors.password.errorComponent}</div>
          </div>

          <div
            className="groupapp-purchase-login-account-content-footer-container"
          >
            <p
              className="groupapp-purchase-login-account-content-footer-highlight forgot-password"
              onClick={() => window.open('/forgot-password?cm=true', '_self')}
            >Forgot Password</p>

            {
              props.group &&
              <TurnstileWidget group={props.group} key={reloadKey}/>
            }

            <button
              className={`groupapp-purchase-login-account-content-footer-action
                ${isDisabled() ? 'footer-action-disabled' : ''}`}
              onClick={handleSubmit}
              disabled={isMakingRequest || isDisabled()}
              style={miscUtils.getBlockButtonStyle(props.theme)}
            >
              {isMakingRequest ? 'Logging in...' : 'Log In'}
            </button>
          </div>
        </div>
      </div>
    </ReactModal>
  )
}

const mapStateToProps = (state: Map<string, any>) => {
  const global = Map(state.get("global", {})).toJS() as any;
  const { theme } = global;
  return {
    theme,
  };
};

export default connect(mapStateToProps)(PurchaseLoginModal);